import { FC } from 'react';
import { Divider, Link } from '@hopskipdrive/react-components';

import Banner from '../../../../assets/hopskipdrive-welcome-banner.png';
import Logo from '../../../../assets/hsd-logo.svg';

import {
  BannerStyled,
  BannerTextMobile,
  Container,
  ContentStyled,
  ContentWrapper,
  FooterStyled,
  PaperStyled,
} from './LoginTemplate.styles';

export interface AuthTemplateProps {
  banner?: boolean;
  children: React.ReactNode;
}

export const LoginTemplate: FC<AuthTemplateProps> = ({ banner = true, children }) => {
  return (
    <Container $hidePaperWhenBannerPresent={banner}>
      {banner && (
        <BannerStyled>
          <desc id="hopskipdrive-banner-description" style={{ display: 'none' }}>
            Welcome to HopSkipDrive RideIQ. Creating opportunity for all through mobility
          </desc>
          <img src={Banner} alt="banner" aria-describedby="hopskipdrive-banner-description" />
        </BannerStyled>
      )}

      <PaperStyled elevation={0} $hidePaperWhenBannerPresent={banner}>
        <ContentWrapper banner={banner}>
          <img src={Logo} alt="HopSkipDrive" className="logo" width={190} height={100} />
          {banner && (
            <BannerTextMobile>
              <p>Welcome to HopSkipDrive RideIQ</p>
              <p>Creating opportunity for all through mobility</p>
            </BannerTextMobile>
          )}
          <ContentStyled>{children}</ContentStyled>
        </ContentWrapper>
        <FooterStyled>
          <Divider color="border" my={1} />
          <p>Trouble Logging in? Contact</p>
          <Link href="mailto:help@hopskipdrive.com">help@hopskipdrive.com</Link>
        </FooterStyled>
      </PaperStyled>
    </Container>
  );
};
